import React, { useState, useEffect } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import { FaTimes } from 'react-icons/fa';
import ToastNotification from '../../../components/ToastNotification';
import Select from 'react-select'
import { useLoading } from '../../../context/LoadingContext';
import { io } from "socket.io-client";
import ToastNotification_Second from '../../../components/ToastNotification_Second';
import socket from "../../../socket";
import {FaBoxOpen,FaQuestionCircle,FaClock,FaTimesCircle, FaCheckCircle} from "react-icons/fa";

const MaterialReceipt = ({ adminData, branchID, financialYear }) => {
    const getTodayDateTime = () => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        return now.toISOString().slice(0, 16);
    };


    const [issue, setIssue] = useState({
        emp_id: '',
        issue_date: getTodayDateTime(),
        ref_doc: '',
        remark: '',
    })
    const [formData, setFormData] = useState([
        {
            id: '',
            qty: '',
            sr_no: '',
            name: "",
            rate: '',
            amount: '',
        }
    ]);

    const [secondToast, setSecondToast] = useState({
        show: false,
        message: '',
        bg: 'warning',
    });

    const showSecondToast = (msg, bg = 'warning') => {
        setSecondToast({ show: true, message: msg, bg });
    };


    const [files, setFiles] = useState({
        file: null,
        existing_file: null,

    })
    const { setLoading } = useLoading();
    const [isEditMode, setIsEditMode] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [user, setUser] = useState([]);
    const [items, setItems] = useState([]);
    const [tech, setTech] = useState([]);
    const [selectedTech, setSelectedTech] = useState(null);
    const [showItemModal, setShowItemModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [selectedDoc, setSelectedDoc] = useState(null)

    const [editingCompanyId, setEditingCompanyId] = useState(null)
    const [noteType, setNoteType] = useState(null);
    const [materialIssue, setMaterialIssue] = useState([]);
    const [branchDetail, setBranchDetail] = useState([])
    const [fetchIssue, setFetchIssue] = useState([])
    const [materialReceipt, setMaterialReceipt] = useState([]);
    const [serialsByItem, setSerialsByItem] = useState({});
    const [receiptSerialPools, setReceiptSerialPools] = useState({});
    const [successfulReturnsByIssue, setSuccessfulReturnsByIssue] = useState({});
    const [receiptIssueItems, setReceiptIssueItems] = useState({});
    const [ownedReceiptSerials, setOwnedReceiptSerials] = useState({});
    const [serialError, setSerialError] = useState({});
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [allDocs, setAllDocs] = useState([]);
    const [pendingReq, setPendingReq] = useState([]);

    const [offset, setOffset] = useState(0);
    const limit = 20;
    const [hasMore, setHasMore] = useState(true);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [isLocked, setIsLocked] = useState(false);
    const [fy, setFy] = useState([]);

    const [showReturnModal, setShowReturnModal] = useState(false);
const [selectedReturn, setSelectedReturn] = useState(null);
const [returnRemark, setReturnRemark] = useState("");
const [returnStatusFilter, setReturnStatusFilter] = useState("All");

    const [financialRange, setFinancialRange] = useState({
        from_date: '',
        to_date: ''
    });

    useEffect(() => {
        const id = selectedDoc?.value;
        if (!id || !branchDetail.code) return;
        let active = true;
        setSuccessfulReturnsByIssue(prev => ({ ...prev, [id]: undefined }));
        axios.get(`https://api.skyguard.group/api/fetch-material-issue/${id}`, { params: { branch_code: branchDetail.code } })
            .then(res => {
                if (!active) return;
                const pool = {};
                const sourceItems = JSON.parse(res.data.items || '[]');
                sourceItems.forEach(item => {
                    const itemId = item.itemId || item.id || item.productId;
                    pool[itemId] = [...(pool[itemId] || []), ...(Array.isArray(item.sr_no) ? item.sr_no : [])];
                });
                setReceiptSerialPools(prev => ({ ...prev, [id]: pool }));
                setReceiptIssueItems(prev => ({ ...prev, [id]: sourceItems }));
                setSuccessfulReturnsByIssue(prev => ({ ...prev, [id]: res.data.successful_receipts || [] }));
            }).catch(error => {
                if (active) showToast(error.response?.data?.error || 'Unable to verify the issue remaining quantity. Please retry.', 'danger');
            });
        return () => { active = false; };
    }, [selectedDoc?.value, branchDetail.code, materialReceipt]);

    const receiptReturns = (id) => (successfulReturnsByIssue[id] || materialReceipt)
        .filter(row => row.return_status === 'Success' && (row.ref_doc === undefined || String(row.ref_doc) === String(id)) && (!isEditMode || String(row.id) !== String(editingCompanyId)));

    const remainingReceiptQuantity = (doc, itemId) => {
        let source;
        try { source = receiptIssueItems[doc.id] || JSON.parse(doc.items || '[]'); } catch { return null; }
        const issued = source.filter(item => String(item.itemId || item.id || item.productId) === String(itemId))
            .reduce((sum, item) => sum + Number(item.qty ?? item.quantity), 0);
        let returned = 0;
        for (const row of receiptReturns(doc.id)) {
            let rows;
            try { rows = JSON.parse(row.items || '[]'); } catch { return null; }
            returned += rows.filter(item => String(item.itemId || item.id || item.productId) === String(itemId))
                .reduce((sum, item) => sum + Number(item.qty ?? item.quantity), 0);
        }
        return Number.isFinite(issued - returned) ? Math.max(0, issued - returned) : null;
    };

    const hasReceiptBalance = (doc) => {
        let rows;
        try { rows = JSON.parse(doc.items || '[]'); } catch { return true; }
        return rows.some(item => {
            const remaining = remainingReceiptQuantity(doc, item.itemId || item.id || item.productId);
            return remaining === null || remaining > 0;
        });
    };

    const receiptItemSerials = (item) => (Array.isArray(item.sr_no) ? item.sr_no : [])
        .map(serial => String(serial).trim()).filter(Boolean);

    const getReceiptSerialPool = (itemId) => {
        const id = selectedDoc?.value;
        if (!id || !Array.isArray(successfulReturnsByIssue[id])) return [];
        const issued = (receiptSerialPools[id]?.[itemId] || []).map(serial => String(serial).trim());
        const otherReturns = new Set(receiptReturns(id)
            .flatMap(row => {
                try { return JSON.parse(row.items || '[]').filter(item => String(item.itemId || item.id || item.productId) === String(itemId)).flatMap(receiptItemSerials); }
                catch { return []; }
            }));
        return Array.from(new Set(issued)).filter(serial => serial && !otherReturns.has(serial));
    };

    const getReceiptSerials = (itemId, qty, rowIndex) => {
        if (!Number.isInteger(Number(qty)) || Number(qty) <= 0) return [];
        const row = formData[rowIndex] || {};
        if (row.serialInput !== undefined) return receiptItemSerials(row);
        const reserved = new Set(formData.flatMap((item, index) => {
            if (index === rowIndex || String(item.id) !== String(itemId)) return [];
            if (index < rowIndex) return getReceiptSerials(item.id, item.qty, index);
            return item.serialInput !== undefined ? receiptItemSerials(item) : [];
        }));
        const available = getReceiptSerialPool(itemId).filter(serial => !reserved.has(serial));
        const preferred = receiptItemSerials(row).filter(serial => available.includes(serial));
        return Array.from(new Set([...preferred, ...available])).slice(0, Number(qty));
    };

    const handleReceiptSerialChange = (index, value) => {
        const serials = value.split(',').map(serial => serial.trim()).filter(Boolean);
        setFormData(prev => prev.map((item, i) => i === index ? { ...item, sr_no: serials, serialInput: value } : item));
    };

    const handleQuantityChange = (index, value) => {
        const qty = Number(value);
        if (value !== '' && (!Number.isInteger(qty) || qty <= 0)) {
            showToast('Quantity must be a positive whole number.', 'danger');
            return;
        }
        const item = formData[index];
        const remaining = selectedDoc?.value ? remainingReceiptQuantity({ id: selectedDoc.value }, item.id) : null;
        const otherQty = formData.reduce((sum, row, i) => i !== index && String(row.id) === String(item.id) ? sum + (Number(row.qty) || 0) : sum, 0);
        if (value !== '' && remaining !== null && qty + otherQty > remaining) {
            showToast('Quantity exceeds the remaining quantity on the referenced issue.', 'danger');
            return;
        }
        const serials = value === '' ? [] : getReceiptSerials(item.id, qty, index).slice(0, qty);
        setFormData(prev => prev.map((row, i) => i === index ? { ...row, qty: value, sr_no: serials, serialInput: undefined } : row));
    };

    useEffect(() => {

        socket.on("material-receipt", (data) => {
            showToast(data.message, "info");
        });

        return () => socket.off("material-receipt");
    }, []);



    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setIssue(prev => ({ ...prev, [name]: value }));
    };


    const addRow = () => {
        setFormData(prev => [...prev, { id: "", name: "", qty: "" }]);
    };


    const docOptions = allDocs
        .filter(doc => branchDetail.code && String(doc.branchId) === String(branchDetail.code))
        .filter(doc => hasReceiptBalance(doc) || (isEditMode && String(doc.id) === String(selectedDoc?.value)))
        .map(item => ({
            value: item.id,
            label: `MIN/${item.id}/${item.branchId}`,
            data: item
        }));

    const filteredDocs = docOptions.filter(option => selectedTech && String(option.data.emp_id) === String(selectedTech.value));


    const options = user.map(t => ({
        value: t.id,
        label: `${t.first} ${t.middle}  ${t.last} - ${t.emp_id}`
    }));

    const typeOptions = [
        { value: "request", label: "Request" },
        { value: "return", label: "Return" }
    ];

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes → MB
            if (fileSizeInMB > 2) {
                setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };


    const handleSelectDoc = (selectedOption) => {
        setSelectedDoc(selectedOption);
        setOwnedReceiptSerials({});

        if (selectedOption && selectedOption.data) {
            const s = selectedOption.data;

            let initialRemark = s.remark || '';
            if (activeReturnMR) {
                initialRemark = initialRemark ? `${initialRemark} [Against Return MR #${activeReturnMR.id}]` : `Against Return MR #${activeReturnMR.id}`;
            }

            setIssue({
                id: s.id,
                emp_id: s.emp_id,
                issue_date: s.issue_date ? s.issue_date.replace(' ', 'T').slice(0, 16) : '',
                ref_doc: String(s.id),
                remark: initialRemark,
            });

            const parsedItems = s.items ? JSON.parse(s.items) : [];
            let finalItems = parsedItems;

            if (activeReturnMR) {
                let reqItems = [];
                try {
                    reqItems = typeof activeReturnMR.items === 'string' ? JSON.parse(activeReturnMR.items) : (activeReturnMR.items || []);
                } catch {
                    reqItems = [];
                }
                finalItems = parsedItems.map(minItem => {
                    const reqMatch = reqItems.find(r => String(r.id || r.itemId) === String(minItem.id || minItem.itemId));
                    if (reqMatch) {
                        const availableQty = remainingReceiptQuantity({ id: s.id }, minItem.id);
                        const reqQty = Number(reqMatch.qty) || 0;
                        const finalQty = reqQty > 0 ? Math.min(reqQty, availableQty) : availableQty;
                        return {
                            ...minItem,
                            qty: finalQty > 0 ? finalQty : 1
                        };
                    }
                    return minItem;
                });
            }

            setFormData(finalItems);

            setFiles({
                file: null,
                existing_file: s.file || null,
            });

            const techOption = options.find(o => String(o.value) === String(s.emp_id)) || null;
            setSelectedTech(techOption);
            setNoteType(s.material_status || null);
        } else {
            setIssue(prev => ({ ...prev, ref_doc: '' }));
            setFormData([]);
        }
    };


    const handleItemChange = (index, itemId) => {
        const selectedItem = items.find(i => i.id === itemId);
        if (!selectedItem) return;

        setFormData(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                id: itemId,
                name: selectedItem.name,
                sr_no: [],
                serialInput: undefined
            };
            return updated;
        });
    };

    const [selectedReturnMRId, setSelectedReturnMRId] = useState(null);
    const [activeReturnMR, setActiveReturnMR] = useState(null);
    const [ambiguousMinMatches, setAmbiguousMinMatches] = useState([]);

    const handleTechChange = (selectedOption) => {
        setSelectedTech(selectedOption);
        setSelectedDoc(null);
        setSelectedReturnMRId(null);
        setActiveReturnMR(null);
        setAmbiguousMinMatches([]);
        setIssue(prev => ({ ...prev, ref_doc: '' }));
        setFormData([]);
        setOwnedReceiptSerials({});
    };

    const techReturnReqs = (fetchIssue || []).filter(item =>
        selectedTech &&
        String(item.emp_id) === String(selectedTech.value) &&
        (item.material_status === 'return' || item.type === 'return')
    );

    const handleApplyReturnMR = (req) => {
        let reqItems = [];
        try {
            reqItems = typeof req.items === 'string' ? JSON.parse(req.items) : (req.items || []);
        } catch {
            reqItems = [];
        }
        if (!reqItems.length) {
            showToast("Selected Return Requisition has no items.", "warning");
            return;
        }

        setSelectedReturnMRId(req.id);
        setActiveReturnMR(req);

        const reqItemIds = new Set(reqItems.map(it => String(it.id || it.itemId)));
        const candidateDocs = filteredDocs.filter(doc => {
            const minItems = doc.data?.items ? (typeof doc.data.items === 'string' ? JSON.parse(doc.data.items) : doc.data.items) : [];
            return minItems.some(it => reqItemIds.has(String(it.id || it.itemId)));
        });

        if (candidateDocs.length === 0) {
            setAmbiguousMinMatches([]);
            setSelectedDoc(null);
            setFormData([]);
            showToast(`No active MIN with returnable balance found for items in MR #${req.id}. Manual MIN selection required.`, "warning");
            return;
        }

        if (candidateDocs.length > 1) {
            // NEVER auto-select when multiple valid matches exist to prevent ambiguous or incorrect allocation
            setAmbiguousMinMatches(candidateDocs);
            setSelectedDoc(null);
            setIssue(prev => ({ ...prev, ref_doc: '' }));
            setFormData([]);
            showToast(`Multiple issued MINs match MR #${req.id} (${candidateDocs.map(d => d.label).join(', ')}). Please explicitly select the specific reference MIN from the dropdown.`, "warning");
            return;
        }

        // Exactly one match: unambiguous auto-selection is safe
        setAmbiguousMinMatches([]);
        const targetDoc = candidateDocs[0];
        handleSelectDoc(targetDoc);

        showToast(`Unambiguous match: MR #${req.id} applied to MIN/${targetDoc.value}. Please verify serial numbers.`, "success");
    };

    const fectEmphDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const filtered = (resEmployee.data.result || []).filter(
                emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
            );

            setUser(filtered);

        } catch (error) {
            console.log(error)
        }
    };
    const fecthInventoryDetail = async () => {
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
            const items = resInventory.data.result || [];
            setItems(items);
        } catch (error) {
            console.log(error)
        }
    };

    const fecthTechDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-technician');
            setTech(resEmployee.data);
        } catch (error) {
            console.log(error)
        }
    };

    const purchaseRequisition = async () => {
        try {
            const result = await axios.get('https://api.skyguard.group/api/fetch-requisition');
            const filteredData = result.data.filter(item => item.material_status === "return");
            setFetchIssue(filteredData);
        } catch (error) {
            console.log(error);
        }
    };



    const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const fetchYearDetail = async () => {
        setLoading(true);
        try {
            const branchCode = await fetchBranchDetail();
            const res = await axios.get(
                `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
            );
            const yearData = res.data;
            setFy(yearData);
            setIsLocked(yearData.is_locked === 1);
            setFinancialRange({
                from_date: yearData.from_date,
                to_date: yearData.to_date
            });

            await fetchMaterialReceipt(
                yearData.from_date,
                yearData.to_date,
                branchCode,

            );
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchMaterialIssue = async () => {
        try {
            const result = await axios.get('https://api.skyguard.group/api/fetch-material-isssue');


            const filteredData = result.data
                .filter(item => item.material_status === 'request')
                .sort((a, b) => b.id - a.id);

            setMaterialIssue(filteredData);
            setAllDocs(filteredData)




        } catch (error) {
            console.log(error);
        }
    };

    const fetchMaterialReceipt = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {

        if (!branchCode) {
            console.log("Branch code missing");
            return;
        }

        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-material-receipt',
                {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
            );


            const sortedData = res.data.sort(
                (a, b) => new Date(b.issue_date) - new Date(a.issue_date)
            );

            // setMaterialReceipt(sortedData);

            const pendingRetun = res.data.filter(r => r.return_status == 'Pending')
            console.log(pendingRetun);

            const result = sortedData;
            if (newOffset === 0) {
                setMaterialReceipt(result);
                setHasMore(true);
            }

            else {
                setMaterialReceipt(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }
        } catch (error) {
            console.log(error)
        }
    };


    const fetchSerials = async (inventoryId, qty) => {
        if (!inventoryId) return;

        try {
            const res = await axios.get(
                "https://api.skyguard.group/api/fetch-inventory-serials",
                { params: { inventory_id: inventoryId } }
            );

            const flattened = Array.isArray(res.data[0]) ? res.data.flat() : res.data;


            const unsoldSerials = Array.from(
                new Map(flattened.map(s => [s.id, s])).values()
            ).filter(s => !s.sold_on || s.sold_on === 0);

            setSerialsByItem(prev => ({
                ...prev,
                [inventoryId]: unsoldSerials
            }));


            if (qty > unsoldSerials.length) {
                setSerialError(prev => ({
                    ...prev,
                    [inventoryId]: `Not enough serial numbers .`
                }));
            } else {
                setSerialError(prev => ({
                    ...prev,
                    [inventoryId]: null
                }));
            }



        } catch (err) {
            console.error("Error fetching serials:", err);
        }
    };



    useEffect(() => {

        fectEmphDetail();
        fecthInventoryDetail();
        fecthTechDetail();
        purchaseRequisition();
        fetchBranchDetail();
        fetchYearDetail();
        fetchSerials();
        fetchMaterialIssue();
    }, []);

    const fullName = `${adminData?.user.first || ''} ${adminData?.user.middle || ''} ${adminData?.user.last || ''}`.trim();

    const editName = `${adminData?.user.first || ''} ${adminData?.user.middle || ''} ${adminData?.user.last || ''}`.trim();


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.some(item => item.id && (!Number.isInteger(Number(item.qty)) || Number(item.qty) <= 0))) {
            showToast('Quantity must be a positive whole number.', 'danger');
            return;
        }

        const cleanedItems = formData
            .map((i, index) => ({
                id: i.id,
                name: i.name,
                qty: Number(i.qty),
                sr_no: getReceiptSerials(i.id, i.qty, index),
                rate: i.rate || 0,
                amount: i.amount || 0,
            })).filter(i => i.id && i.qty);

        const refId = selectedDoc?.value;
        if (!refId || !Array.isArray(successfulReturnsByIssue[refId])) {
            showToast('Verify the referenced issue before saving. Please retry the issue selection.', 'danger');
            return;
        }
        const totals = new Map();
        cleanedItems.forEach(item => totals.set(String(item.id), (totals.get(String(item.id)) || 0) + item.qty));
        if (!cleanedItems.length || [...totals].some(([itemId, qty]) => {
            const remaining = remainingReceiptQuantity({ id: refId }, itemId);
            return !Number.isFinite(qty) || qty <= 0 || remaining === null || qty > remaining;
        })) {
            showToast('Receipt quantities must fit the remaining quantity on the referenced issue.', 'danger');
            return;
        }

        const usedSerials = new Map();
        if (cleanedItems.some(item => {
            const used = usedSerials.get(String(item.id)) || new Set();
            const pool = getReceiptSerialPool(item.id);
            const invalid = item.sr_no.length !== item.qty || item.sr_no.some(serial => {
                if (!pool.includes(serial) || used.has(serial)) return true;
                used.add(serial);
                return false;
            });
            usedSerials.set(String(item.id), used);
            return invalid;
        })) {
            showToast('Select one distinct issued serial per unit from the referenced issue.', 'danger');
            return;
        }

        const sendData = new FormData();
        sendData.append('ref_doc', selectedDoc?.value || '');
        sendData.append("note_type", "material_receipt");
        sendData.append("emp_id", selectedTech?.value || "");
        sendData.append("material_status", 'return');
        sendData.append("issue_date", issue.issue_date || new Date().toISOString().slice(0, 16));
        sendData.append("remark", issue.remark);
        sendData.append("items", JSON.stringify(cleanedItems));
        sendData.append("existing_file", files.existing_file || "")
        sendData.append('added_by', fullName)
        sendData.append("branchId", branchDetail.code);
        sendData.append("return_status", "Pending");

        if (files.file) {

            sendData.append("file", files.file);
        }

        try {
            if (isEditMode && editingCompanyId) {
                sendData.append("edit_by", editName);
                await axios.put(
                    `https://api.skyguard.group/api/update-material-receipt-note/${editingCompanyId}`,
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Material Return updated successfully!", "success");
            } else {
                await axios.post(
                    "https://api.skyguard.group/api/material-receipt-note",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Material Return note created successfully!", "success");
            }

            fetchMaterialReceipt(financialRange.from_date,
                financialRange.to_date,
                branchDetail.code,
                0);
            setShowAddForm(false);
            setIsEditMode(false);

            setIssue({
                emp_id: '',
                issue_date: '',
                ref_doc: '',
                remark: '',
            })


            setFormData([]);
            setNoteType([])
            setSelectedTech(null)
            setSelectedDoc([]);



        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);

            console.error('❌ FULL ERROR:', err);
            console.error('❌ MESSAGE:', err.message);
            console.error('❌ STACK:', err.stack);

            // showToast("Failed to create material return note!", "danger");
            showToast(
                err.response?.data?.message ||
                err.response?.data?.error ||
                err.message ||
                "Failed to create material receipt note!",
                "danger"
            );
        }
    };


    const handleEdit = (s) => {

        let parsedItems = [];
        try {
            parsedItems = s.items ? JSON.parse(s.items) : [];
        } catch (err) {
            console.error("❌ Error parsing items JSON:", err);
        }

        setIssue({
            id: s.id || '',
            emp_id: s.emp_id || '',
            issue_date: s.issue_date ? s.issue_date.replace(' ', 'T').slice(0, 16) : '',
            ref_doc: s.ref_doc || '',
            remark: s.remark || '',
            branchId: s.branchId || "",
        });

        setFormData(parsedItems);
        const owned = {};
        parsedItems.forEach(item => { owned[item.id] = [...(owned[item.id] || []), ...(Array.isArray(item.sr_no) ? item.sr_no : [])]; });
        setOwnedReceiptSerials(owned);

        setFiles({
            file: null,
            existing_file: s.file || null,
        });


        const tech = options.find(opt => String(opt.value) === String(s.emp_id));
        setSelectedTech(tech || null);
        setNoteType(s.material_status || null);
        const docOption = docOptions.find(
            opt => opt.value === Number(s.ref_doc)
        );
        setSelectedDoc(/^[1-9]\d*$/.test(String(s.ref_doc)) ? docOption || {
            value: Number(s.ref_doc),
            label: `MIN/${s.ref_doc}/${s.branchId}`
        } : null);

        setEditingCompanyId(s.id);
        setIsEditMode(true);
        setShowAddForm(true);
    };

    const resetForm = () => {

        // setShowAddForm(false);
        setIsEditMode(false);

        setIssue({
            emp_id: '',
            issue_date: '',
            ref_doc: '',

            remark: '',
        })

        setFormData([]);
        setNoteType([])
        setSelectedTech(null)
        setSelectedDoc([]);
    }

    const getSerialNumbers = (inventory_id, qty) => {
        if (!inventory_id || !qty) return [];

        const list = serialsByItem[inventory_id] || [];

        // Only take as many as qty
        return list.slice(0, qty).map(s => s.sr_no);
    };


    // const filteredData = searchTerm
    //     ? materialReceipt.filter(itm =>
    //         Object.values(itm).some(val =>
    //             String(val || '').toLowerCase().includes(searchTerm.toLowerCase())
    //         )
    //     )
    //     : materialReceipt;

    const filteredData = materialReceipt.filter((itm) => {

    // Search filter
    const matchesSearch = searchTerm
        ? Object.values(itm).some(val =>
            String(val || "")
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
        )
        : true;

    // Return status filter
    const matchesStatus =
        returnStatusFilter === "All"
            ? true
            : String(itm.return_status || "").toLowerCase() ===
              returnStatusFilter.toLowerCase();

    return matchesSearch && matchesStatus;
});

    const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        fetchMaterialReceipt(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };

const handleReturnStatus = async (status) => {
  if (!selectedReturn) return;

  if (!returnRemark.trim()) {
    showToast("Please enter a remark");
    return;
  }

  try {
    const payload = {
   
      items: selectedReturn.items || [],
      note_type: selectedReturn.note_type || "",
      material_status: selectedReturn.material_status || "",
      edit_by: editName || "",
      return_status: status,
      return_remark: returnRemark.trim()
    };



    await axios.put(
      `https://api.skyguard.group/api/material-return-status/${selectedReturn.id}`,
      payload
    );

    showToast(
      status === "Success"
        ? "Return request marked as Success"
        : "Return request Rejected"
    );

    setShowReturnModal(false);
    setSelectedReturn(null);
    setReturnRemark("");

     fetchMaterialReceipt(financialRange.from_date,
                financialRange.to_date,
                branchDetail.code,
                0);

  } catch (error) {
    console.error("Return status update error:", error);

    showToast(
      error.response?.data?.error ||
      "Failed to update return status"
    );
  }
};

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Material Return</h3>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />

                    <div className="mb-3 row gx-2 gy-2 d-flex justify-content-between">
                        <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                            <div class="col-12 col-md-9">
                                <div className="row my-3 align-items-center">

                                    {/* Input */}
                                    <div className="col-md-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search By name,type"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>

                            </div>

                            {/* <div className="col-12 col-md-2 d-flex justify-content-end gap-2">
                                <button
                                    className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => {
                                        setShowAddForm(!showAddForm);
                                        resetForm();
                                    }}
                                >
                                    {showAddForm ? 'Cancel' : 'Add'}{' '}
                                    {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
                                </button>
                            </div> */}

                            <div className="col-12 col-md-2 d-flex flex-column align-items-end gap-2">

    {/* ADD BUTTON */}
    <button
        className={`btn ${
            showAddForm ? "btn-danger" : "btn-success"
        }`}
        onClick={() => {
            setShowAddForm(!showAddForm);
            resetForm();
        }}
    >
        {showAddForm ? "Cancel" : "Add"}{" "}
        {showAddForm ? (
            <FaTimes size={18} />
        ) : (
            <AiOutlinePlusCircle size={20} />
        )}
    </button>

    {/* RETURN STATUS FILTER */}
    <div style={{ width: "200px" }}>
        <Select
            value={{
                value: returnStatusFilter,
                label: returnStatusFilter
            }}
            onChange={(selected) => {
                setReturnStatusFilter(selected.value);
            }}
            options={[
                {
                    value: "All",
                    label: "All Status"
                },
                {
                    value: "Pending",
                    label: "Pending"
                },
                {
                    value: "Success",
                    label: "Success"
                },
                {
                    value: "Reject",
                    label: "Reject"
                }
            ]}
            isSearchable={false}
            placeholder="Filter Status"
            styles={{
                control: (base) => ({
                    ...base,
                    minHeight: "38px",
                    fontSize: "14px"
                }),
                menu: (base) => ({
                    ...base,
                    zIndex: 9999
                })
            }}
        />
    </div>

</div>

                         

                            {/* <div className="col-12 col-md-2 d-flex justify-content-end gap-2">
  <button
    type="button"
    className={`btn flex-fill ${
      showAddForm ? "btn-danger" : "btn-success"
    }`}
    onClick={() => {
      setShowAddForm(!showAddForm);
      resetForm();
    }}
  >
    {showAddForm ? "Cancel" : "Add"}{" "}
    {showAddForm ? (
      <FaTimes size={18} />
    ) : (
      <AiOutlinePlusCircle size={20} />
    )}
  </button>

  <button
    type="button"
    className="btn btn-warning flex-fill"
  >
    Pending: {pendingReq.length}
  </button>
</div> */}

                        </div>
                    </div>

                    {showAddForm && (
                        <div className='card p-3 mb-4'>
                            {isEditMode && (
                                <div className="mb-3">
                                    <label>Document No:</label> <br />
                                    <span className="badge bg-primary px-3 py-2">

                                        {`MRN/${issue.issue_id || issue.id}/${issue.branchId || ""}`}
                                    </span>
                                </div>
                            )}
                            <form className='row g-3' onSubmit={handleSubmit} >


                                <div className="col-md-4">
                                    <label>Select Technician Name</label>
                                    <Select
                                        options={options}
                                        value={selectedTech}
                                        onChange={handleTechChange}
                                        placeholder="Select Technician"
                                        isClearable
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label>Reference Document {ambiguousMinMatches.length > 1 && <span className="text-danger small">(Explicit selection required)</span>}</label>
                                    <Select
                                        options={ambiguousMinMatches.length > 0 ? ambiguousMinMatches : filteredDocs}
                                        value={selectedDoc}
                                        onChange={handleSelectDoc}
                                        placeholder={ambiguousMinMatches.length > 1 ? "⚠️ Select from matching MINs..." : "Select Reference"}
                                        isDisabled={!selectedTech}
                                        isClearable
                                    />
                                </div>



                                <div className="col-md-4">
                                    <label>Date</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"

                                        name="issue_date"
                                        value={issue.issue_date}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                {selectedTech && techReturnReqs.length > 0 && (
                                    <div className="col-12 mt-2 mb-1">
                                        <div className="alert alert-info py-2 px-3 mb-0">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <strong><FaBoxOpen className="me-1 text-primary" /> Eligible Return Requisitions for Technician ({techReturnReqs.length}):</strong>
                                                <small className="text-muted">Select an MR to match and load corresponding issued MIN & items</small>
                                            </div>
                                            <div className="table-responsive bg-white rounded border">
                                                <table className="table table-sm table-hover mb-0 align-middle">
                                                    <thead className="table-light small">
                                                        <tr>
                                                            <th>MR No.</th>
                                                            <th>Date</th>
                                                            <th>Requested Items</th>
                                                            <th>Remark</th>
                                                            <th className="text-center">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="small">
                                                        {techReturnReqs.map((req) => {
                                                            let reqItems = [];
                                                            try { reqItems = typeof req.items === 'string' ? JSON.parse(req.items) : (req.items || []); } catch { reqItems = []; }
                                                            const isSelected = selectedReturnMRId === req.id;
                                                            return (
                                                                <tr key={req.id} className={isSelected ? 'table-primary fw-semibold' : ''}>
                                                                    <td>MR/{req.id}</td>
                                                                    <td>{req.issue_date ? req.issue_date.slice(0, 10) : ''}</td>
                                                                    <td>
                                                                        {reqItems.map((it, i) => (
                                                                            <span key={i} className="badge bg-secondary me-1">
                                                                                {it.name || `Item #${it.id}`} ({it.qty})
                                                                            </span>
                                                                        ))}
                                                                    </td>
                                                                    <td>{req.remark || '-'}</td>
                                                                    <td className="text-center">
                                                                        <button
                                                                            type="button"
                                                                            className={`btn btn-xs py-0 px-2 ${isSelected ? 'btn-success' : 'btn-outline-primary'}`}
                                                                            onClick={() => handleApplyReturnMR(req)}
                                                                        >
                                                                            {isSelected ? '✓ Selected' : 'Use this MR'}
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {ambiguousMinMatches.length > 1 && (
                                    <div className="col-12 mt-2 mb-2">
                                        <div className="alert alert-warning py-2 px-3 mb-0 small">
                                            <strong>⚠️ Ambiguous allocation prevented:</strong> Multiple issued documents ({ambiguousMinMatches.map(d => d.label).join(', ')}) contain returnable items for MR #{selectedReturnMRId}. <strong>Explicit selection required:</strong> please choose the exact reference MIN from the dropdown above.
                                        </div>
                                    </div>
                                )}

                                <div className="table-responsive my-4">

                                    <div className="col-md-12 text-end mb-2">
                                        <button
                                            type='button'
                                            className="btn btn-success"
                                            onClick={addRow}
                                        >
                                            + Add Row
                                        </button>
                                    </div>


                                    <table className="table table-bordered mx-auto text-center align-middle w-75">
                                        <thead className="table-primary">
                                            <tr>
                                                <th style={{ width: "300px" }}>Item</th>
                                                <th style={{ width: "100px" }} >Qty</th>
                                                <th style={{ width: "100px" }} >Sr No</th>
                                                <th style={{ width: "100px" }}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {formData.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-primary w-100"
                                                            onClick={() => {
                                                                setActiveRowIndex(idx);
                                                                setShowItemModal(true);
                                                            }}
                                                        >
                                                            {item.name ? item.name : "Search Item"}
                                                        </button>
                                                    </td>


                                                    {/* Qty */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            min="1"
                                                            step="1"
                                                            value={item.qty}
                                                            onChange={(e) => handleQuantityChange(idx, e.target.value)}
                                                        />
                                                    </td>

                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            aria-label={`Sr No ${idx + 1}`}
                                                            list={`receipt-serials-${idx}`}
                                                            disabled={!Array.isArray(successfulReturnsByIssue[selectedDoc?.value])}
                                                            value={
                                                                item.serialInput ?? getReceiptSerials(item.id, item.qty, idx).join(', ')
                                                            }
                                                            onChange={(e) => handleReceiptSerialChange(idx, e.target.value)}
                                                        />
                                                        <datalist id={`receipt-serials-${idx}`}>
                                                            {getReceiptSerialPool(item.id).map(serial => <option key={serial} value={serial} />)}
                                                        </datalist>

                                                        {serialError[item.id] && (
                                                            <small className="text-danger">{serialError[item.id]}</small>
                                                        )}
                                                    </td>

                                                    {/* Delete */}
                                                    <td>
                                                        <button
                                                            type='button'
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                setFormData(formData.filter((_, i) => i !== idx))
                                                            }
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>

                                <div className="row">

                                    <div className="col-md-6">
                                        <label>Upload attachment</label>

                                        {isEditMode && files.existing_file && (
                                            <div className="mt-2">
                                                <small>Current File:</small>
                                                <a
                                                    href={`https://api.skyguard.group/uploads/${files.existing_file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {files.existing_file}
                                                </a>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="attachment"
                                            name="file"
                                            accept="image/*,application/pdf"
                                            onChange={handleFileChange}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label>Remark</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows="5"
                                            placeholder="Enter description here..."
                                            name="remark"
                                            value={issue.remark}
                                            onChange={handleInputChange}
                                            disabled={isEditMode}
                                        ></textarea>
                                    </div>


                                </div>

                                <div className="col-md-12 d-grid d-flex justify-content-end">
                                    <button type="submit" className='btn btn-success w-10'>
                                        {isEditMode ? "Update" : "Save"}
                                    </button>
                                    <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                        setShowAddForm(false);
                                        setIsEditMode(false);
                                        setIssue({
                                            emp_id: '',
                                            issue_date: '',
                                            ref_doc: '',
                                            remark: '',
                                        })
                                        setFormData([]);
                                        setSelectedDoc([]);
                                        setNoteType([])
                                        setSelectedTech([]);
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* table */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th scope='col'>SN</th>
                                    <th scope='col'>Action</th>
                                    <th scope='col'>Doc No.</th>
                                    <th scope='col'>Techinician</th>
                                    <th scope='col'>Techinician Reference</th>
                                    <th scope='col'>Added By</th>
                                    <th scope='col'>Date</th>
                                    <th scope='col'>Edit By</th>
                                    <th scope='col'>Edit Date</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((s, idx) => (
                                    <tr key={idx}>
                                        {/* <td>{idx + 1}</td> */}
                                        <td>{filteredData.length - idx}</td>
                                        <td>
                                            <button type="button"
                                                className='btn btn-primary mx-2'
                                                onClick={() => handleEdit(s)}

                                            >
                                                <AiOutlineEdit size={20} title='Edit' />
                                            </button>

                                          <button
  className={`btn btn-sm ${
    s.return_status === "Pending"
      ? "btn-warning"
      : s.return_status === "Success"
        ? "btn-success"
        : "btn-danger"
  }`}
  disabled={s.return_status !== "Pending"}
  onClick={() => {
    if (s.return_status === "Pending") {
      setSelectedReturn(s);
      setReturnRemark("");
      setShowReturnModal(true);
    }
  }}
>
  {s.return_status}
</button>
                                        </td>
                                        <td> {`MRN/${s.id}/${s.branchId}/${fy.financial_year.split('-')[0]}`} </td>

                                        <td>
                                            {[
                                                s.tech_first_name,
                                                s.tech_middle_name,
                                                s.tech_last_name
                                            ]
                                                .filter(Boolean)
                                                .join(" ")}
                                        </td>

                                        <td>{new Date(s.issue_date).toLocaleString()}</td>
                                        <td>{s.added_by} </td>
                                        <td> {s.issue_date} </td>
                                        <td>{s.edit_by} </td>
                                        {/* <td>{s.edit_date} </td> */}
                                        <td>
                                            {s.edit_date
                                                ? new Date(s.edit_date).toLocaleString("en-IN", {
                                                    timeZone: "Asia/Kolkata"
                                                })
                                                : "-"}
                                        </td>


                                    </tr>



                                ))}

                                {filteredData.length === 0 && (
                                    <tr>
                                        <td colSpan="6" className='text-center text-muted'>
                                            No records found.
                                        </td>
                                    </tr>
                                )}


                            </tbody>
                        </table>
                        {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </div>
                    {showItemModal && (
                        <div className="modal fade show d-block " style={{ background: "rgba(0,0,0,.5)" }}>
                            <div className="modal-dialog modal-lg ">
                                <div className="modal-content ">

                                    <div className="modal-header">
                                        <h5 className="modal-title">Select Item</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowItemModal(false)}
                                        />
                                    </div>

                                    <div className="modal-body">
                                        {/* 🔍 Search */}
                                        <input
                                            type="text"
                                            className="form-control mb-3"
                                            placeholder="Search by item name..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />

                                        {/* Item list */}
                                        <div className='table-responsive'>
                                            <table className="table table-bordered ">
                                                <thead className='table-dark'>
                                                    <tr>
                                                        <th>Name</th>
                                                        {/* <th>Stock</th> */}
                                                        <th width="100">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items
                                                        .filter(i =>
                                                            i.name.toLowerCase().includes(searchText.toLowerCase())
                                                        )
                                                        .map(i => (
                                                            <tr key={i.id}>
                                                                <td>{i.name}</td>
                                                                {/* <td>{i.stock}</td> */}
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-success"
                                                                        onClick={() => {
                                                                            handleItemChange(activeRowIndex, i.id);
                                                                            setShowItemModal(false);
                                                                            setSearchText("");
                                                                        }}
                                                                    >
                                                                        Select
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {hasMore && (
                                            <div className="text-center mt-3">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={handleLoadMore}
                                                >
                                                    Load More
                                                </button>
                                            </div>
                                        )}

                                    </div>

                                </div>
                            </div>
                        </div>
                    )}

{showReturnModal && selectedReturn && (
  <>
    {/* Backdrop */}
    <div
      className="modal-backdrop fade show"
      style={{ zIndex: 1040 }}
    />

    {/* Modal */}
    <div
      className="modal fade show"
      style={{
        display: "block",
        zIndex: 1050
      }}
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg"
          style={{
            borderRadius: "14px",
            overflow: "hidden"
          }}
        >

          {/* HEADER */}
          <div
            className="modal-header border-0 px-4 py-3"
            style={{
              background: "#f8f9fa"
            }}
          >
            <div className="d-flex align-items-center gap-3">

              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "50%",
                  background: "#fff3cd",
                  color: "#856404",
                  fontSize: "20px"
                }}
              >
                <FaBoxOpen />
              </div>

              <div>
                <h5 className="mb-1 fw-semibold">
                  Material Return Request
                </h5>

                <small className="text-muted">
                  Review and update the return status
                </small>
              </div>

            </div>

            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setShowReturnModal(false);
                setSelectedReturn(null);
                setReturnRemark("");
              }}
            />
          </div>


          {/* BODY */}
          <div className="modal-body px-4 py-4">

            {/* Confirmation */}
            <div
              className="text-center mb-4"
              style={{
                padding: "18px",
                background: "#f8f9fa",
                borderRadius: "10px"
              }}
            >

              <div
                className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "50%",
                  background: "#e7f1ff",
                  color: "#0d6efd",
                  fontSize: "24px"
                }}
              >
                <FaQuestionCircle />
              </div>

              <h6 className="fw-semibold mb-2">
                Confirm Return Request
              </h6>

              <p className="text-muted mb-0 small">
                Are you sure you want to update this
                material return request?
              </p>

            </div>


            {/* CURRENT STATUS */}
            <div className="mb-3">

              <label className="form-label fw-semibold small text-muted">
                Current Status
              </label>

              <div>
                <span
                  className="badge rounded-pill px-3 py-2"
                  style={{
                    background: "#fff3cd",
                    color: "#856404",
                    fontSize: "13px"
                  }}
                >
                  <FaClock
                    size={12}
                    className="me-1"
                  />

                  {selectedReturn.return_status}
                </span>
              </div>

            </div>


            {/* REMARK */}
            <div className="mb-2">

              <label className="form-label fw-semibold">
                Remark
                <span className="text-danger ms-1">
                  *
                </span>
              </label>

              <textarea
                className="form-control"
                rows="4"
                placeholder="Enter your remark..."
                value={returnRemark}
                onChange={(e) =>
                  setReturnRemark(e.target.value)
                }
                style={{
                  borderRadius: "8px",
                  resize: "none"
                }}
              />

              <small className="text-muted">
                Please provide a reason or note for this decision.
              </small>

            </div>

          </div>


          {/* FOOTER */}
          <div
            className="modal-footer border-0 px-4 py-3"
            style={{
              background: "#f8f9fa"
            }}
          >

            {/* CANCEL */}
            <button
              type="button"
              className="btn btn-outline-secondary px-4"
              onClick={() => {
                setShowReturnModal(false);
                setSelectedReturn(null);
                setReturnRemark("");
              }}
              style={{
                borderRadius: "7px"
              }}
            >
              Cancel
            </button>


            <div className="d-flex gap-2 ms-auto">

              {/* REJECT */}
              <button
                type="button"
                className="btn btn-danger px-4"
                onClick={() =>
                  handleReturnStatus("Reject")
                }
                style={{
                  borderRadius: "7px"
                }}
              >
                <FaTimesCircle
                  className="me-1"
                />

                Reject
              </button>


              {/* APPROVE */}
              <button
                type="button"
                className="btn btn-success px-4"
                onClick={() =>
                  handleReturnStatus("Success")
                }
                style={{
                  borderRadius: "7px"
                }}
              >
                <FaCheckCircle
                  className="me-1"
                />

                Approve
              </button>

            </div>

          </div>

        </div>
      </div>
    </div>
  </>
)}
                </div>
            </div>
        </>
    )
}
export default MaterialReceipt
